import makeBenefitsHub from '@main/factories/pages/makeBenefitsHub';
import { useData } from 'vike-react/useData';

import type { Data } from './+data';

export function Page() {
	const { topics } = useData<Data>();

	return makeBenefitsHub(topics);
}
